import { useParams } from "react-router-dom";
import AgencyForm from "../../components/form/AgencyForm";
import TabsComponent from "../../components/main/Tabs";
import { useGetAgencyQuery } from "../../store/services/AgencyService";
import { listAgencyTabs } from "../../utils/listTabs/ListAgencyTabs";
import Loader from "../../components/main/Loader";
import { useEffect } from "react";
import { setCurrentTab } from "../../store/feautures/TabSlice";
import { useDispatch } from "react-redux";

export default function AgencyActionsPage() {

    const { id } = useParams();
    const { isLoading, data }: any = useGetAgencyQuery(id);
    const dispatch = useDispatch();

    useEffect(() => {
        return(() => {
            dispatch(setCurrentTab({selectedTab: 0}));
        });
    }, [])

    return (

        isLoading
            ? <Loader />
            : <div className="flex flex-col gap-6">
                <div className="bg-white shadow-lg rounded-lg">
                    <AgencyForm type="update" dataInfo={data?.result} />
                </div>
                
                <TabsComponent categories={listAgencyTabs(data?.result?.categorieLavoratori, data?.result?.documentiAziendali, id)} />
            </div>
    )
}